import { render, staticRenderFns } from "./EditRecommendedClasses.vue?vue&type=template&id=685686b6"
import script from "./EditRecommendedClasses.vue?vue&type=script&lang=js"
export * from "./EditRecommendedClasses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports